import React, { useState } from 'react';
import "./styelLogin.css";
import svgbot from "../../../assets/images/chatgpt robot with speech bubblebot-login.png";
import { Link, useNavigate } from 'react-router-dom';

function LoginPage() {
    const [val, setVal] = useState({
        email: "",
        password: "",
    });
    const navigate = useNavigate();
    const handleSubmit = () => {
        // if(val.email==="" && val.password===""){
        //     alert("Please Fill All Feilds");
        // }
        // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val.email)) {

        //     //firebase api call for the authentication
        //     // signInWithEmailAndPassword(auth, val.email,val.password)
        //     //     .then((res) => {
        //     //         alert("Sucessfull");
        //     //     }).catch((err => alert("Wrong Authentication")));
        // } else {
        //     alert("You have entered an invalid email address!")
        //     return (false)
        // }
        navigate('/dashboard');
    }

    return (
        <div className='login'>
            <div className='login-container'>
                <div className='login-svg'>
                    <svg className='csvg1' width="200" height="197" viewBox="0 0 200 197" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="100" cy="97" r="100" fill="#0E325E" fill-opacity="0.74" />
                    </svg>
                    <svg className="csvg2" width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="100" cy="100" r="100" fill="#0E325E" fill-opacity="0.74" />
                    </svg>
                    <img className='svgbot' src={svgbot} alt='/' />
                </div>
                <div className='login-info-conatiner'>
                    <div className='login-title'>
                        <h1>LOGIN</h1>
                    </div>
                    <div className='input-container'>
                        <input type='text' placeholder='Email id' onChange={(event) => setVal((prev) => ({ ...prev, email: event.target.value }))} />
                        <input type='password' placeholder='PASSWORD' onChange={(event) => setVal((prev) => ({ ...prev, password: event.target.value }))} />
                        <button className='btnsubmit' onClick={handleSubmit}>SUBMIT</button>
                        <Link to='/forget-password'>Forget Password</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginPage
